import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { TABLE_HEADERS, keyMapping } from '../../../../../constants/Wheels';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';

const Wheels = () => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchWheelData();
  }, []);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchWheelData(newPage);
  };

  const fetchWheelData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/wheel/list',
        {
          orderBy: 'wheel_id desc',
          page,
          pageSize,
          searchText:searchTerm
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log('response', response);
      setTableData(formattedData);
     // toastSuccess("Product Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching unit list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const handleEditButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.WHEELSEDIT}`, { state: { data: rowData } });
    console.log("rowdata", rowData)
  }


  useEffect(() => {
    if (searchTerm === "") {
      fetchWheelData();
    }
  }, [searchTerm]);
  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
          <h5>Wheels</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
        <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText" >{totalData} </h5>
            <h6>All Wheels</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText" >{totalActive} </h5>
            <h6>Active Wheels</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText" >{totalInactive} </h5>
            <h6>Inactive Wheels</h6>
          </div>
          <button
            className='addcustomerbutton'
            onClick={() => navigate(ROUTES_NAVIGATION.WHEELSADD)}
          >
            Add Wheels
          </button>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
        <div className='listsearchContainer'>
          <h5>Wheels List</h5>
          <div>
              <SearchInput
                placeholder="Search No. Of Wheels"
                onSearch={fetchWheelData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
         
        </div>

        <CustomTable
          data={tableData}
          headers={TABLE_HEADERS}
          keyMapping={keyMapping}
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEditButton}
          totalRecords={totalRecords} 
        />
      </div>
    </div>
     )}
  </div>
  );
};

export default Wheels;
